import React from 'react';
import { z } from 'zod';
import { COLOR_SCHEMA } from '../color';
import { FONT_FAMILY_SCHEMA, getFontFamily } from '../fonts';
import { getPadding, PADDING_SCHEMA } from '../padding';
export const ShortcodePropsSchema = z.object({
    style: z
        .object({
        color: COLOR_SCHEMA,
        backgroundColor: COLOR_SCHEMA,
        fontFamily: FONT_FAMILY_SCHEMA,
        fontSize: z.number().min(0).optional().nullable(),
        textAlign: z.enum(['left', 'right', 'center']).optional().nullable(),
        padding: PADDING_SCHEMA,
    })
        .optional()
        .nullable(),
    props: z
        .object({
        contents: z.string().optional().nullable(),
    })
        .optional()
        .nullable(),
});
export function Shortcode({ style, props }) {
    var _e, _t, _y, _10;
    const children = props === null || props === void 0 ? void 0 : props.contents;
    const cssStyle = {
        color: (_e = style === null || style === void 0 ? void 0 : style.color) !== null && _e !== void 0 ? _e : undefined,
        backgroundColor: (_t = style === null || style === void 0 ? void 0 : style.backgroundColor) !== null && _t !== void 0 ? _t : undefined,
        fontFamily: getFontFamily(style === null || style === void 0 ? void 0 : style.fontFamily),
        fontSize: (_y = style === null || style === void 0 ? void 0 : style.fontSize) !== null && _y !== void 0 ? _y : undefined,
        textAlign: (_10 = style === null || style === void 0 ? void 0 : style.textAlign) !== null && _10 !== void 0 ? _10 : undefined,
        padding: getPadding(style === null || style === void 0 ? void 0 : style.padding),
    };
    if (!children) {
        return React.createElement("div", { style: cssStyle });
    }
    return React.createElement("div", { style: cssStyle, dangerouslySetInnerHTML: { __html: children } });
}
//# sourceMappingURL=Shortcode.js.map